import styled, { css } from 'styled-components'

export const PillButton = styled.button(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${theme.spacing.xSmall};
        flex-shrink: 0;
        height: 2.15rem;
        padding: ${theme.spacing.xxxSmall} 0.8125rem ${theme.spacing.xxxSmall} 0.5625rem;
        border: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwPremiumBackground};
        border-radius: 8rem;
        background-color: ${theme.colors.tfwPremiumBackground};
        color: ${theme.colors.tfwBlack87};
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        white-space: nowrap;
        cursor: pointer;
    `,
)
